import {
  SAVE_CRITERIA,
  SAVE_SEARCH_CRITERIA,
  SAVE_GRID_CRITERIA
} from 'actions';

function home(state = {
  searchCriteria: null,
  gridCriteria: null
}, action) {
  switch (action.type) {
    case SAVE_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: action.searchCriteria
      };
    case SAVE_GRID_CRITERIA:
      return {
        ...state,
        gridCriteria: action.gridCriteria
      };
    case SAVE_CRITERIA:
      return {
        ...state,
        searchCriteria: action.searchCriteria,
        gridCriteria: action.gridCriteria
      };
    default:
      return state;
  }
}

export default home;
